import { useLocation, useNavigate } from 'react-router-dom'

import { Tabs } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

const TABS = {
  SETTINGS: 'settings',
  EMPLOYEES: 'employees',
}

interface Props {
  canAssignEmployees: boolean
}

const CalendarTabs = ({ canAssignEmployees }: Props) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { navigation } = useNavigation()
  const { id } = useStrictParams<'id'>()

  const tabs = [
    {
      id: TABS.SETTINGS,
      label: i18n.t('settings.work_schedule.settings_tab.tab'),
      href: navigation.settings.workSchedule.id.edit.fullPath({ id }),
    },
    canAssignEmployees
      ? {
          id: TABS.EMPLOYEES,
          label: i18n.t('settings.work_schedule.employees_tab.tab'),
          href: navigation.settings.workSchedule.id.employees.fullPath({ id }),
        }
      : null,
  ].filter(Boolean)

  return (
    <Tabs currentId={pathname} onTabClicked={(tabId) => navigate(tabId)} hasAdditionalPadding>
      {tabs.map((tab) => (
        <Tabs.Tab key={tab.id} id={tab.href} label={tab.label} />
      ))}
    </Tabs>
  )
}

export default CalendarTabs
